'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  UserTypeId: 1,
  Name: 'Member'
}, {
  UserTypeId: 2,
  Name: 'Regulator'
}];


// WEBPACK FOOTER //
// ./common/utilities/user-type.js